import React from 'react'
import { Box, Typography } from '@mui/material'

export const AccountSummary = (props) => {
  const { accountData, isLoading, tlpRedeemData, tlpIsLoading, displayTlp } = props

  const infoArray = [
    {
      label: 'Account Number: ',
      value: isLoading ? 'Loading...' : accountData[0]?.companyAccountId,
    },
    { label: 'Company Name: ', value: isLoading ? 'Loading...' : accountData[0]?.companyName },
    { label: 'Sales: ', value: isLoading ? 'Loading...' : accountData[0]?.salesId },
    {
      label: 'Total Point: ',
      value: isLoading ? 'Loading...' : accountData[0]?.totalPoint.toFixed(2),
    },
    ...(displayTlp
      ? [
          {
            label: 'TLP Redeem: ',
            value: tlpIsLoading ? 'Loading...' : tlpRedeemData?.[0]?.tlp2022 ?? 0,
          },
        ]
      : [{}]),
  ]

  return (
    <Box mb={3}>
      {infoArray.map((info, idx) => (
        <Box
          key={idx}
          display='flex'
          alignItems='center'
          boxShadow='2px 2px 7px 0px rgba(0, 0, 0, 0.05)'
          padding='8px 12px'
          borderRadius='8px'
        >
          <Typography maxWidth={150} width='100%' fontSize={16}>
            {info.label}
          </Typography>
          <Typography fontSize={16}>{info.value}</Typography>
        </Box>
      ))}
    </Box>
  )
}
